module.exports = "/static/assets/44507755b21849685b8d585950b7a037.png";